import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import wildlifeData from '../data/wildlifeData';
import WildlifePhotoCard from '../components/wildlifePhotoCard';

const WildSidePage = () => {
    return (
        <Box
            sx={{
                backgroundColor: '#000000',
                minHeight: '100vh',
                width: '100%',
                overflowX: 'hidden',
                padding: { xs: 2, sm: 4 },
                display: 'flex',
                justifyContent: 'center',
            }}
        >
            <Box sx={{ width: '100%', maxWidth: { xs: '100%', sm: 600, md: 900 }, minWidth: 0, mx: 'auto' }}>
                <Typography variant="h3" sx={{ fontWeight: 'bold', color: 'white', textAlign: 'center', mb: 1, fontSize: { xs: '2rem', sm: '2.5rem' } }}>
                    The Wild Side
                </Typography>
                <Typography variant="h6" sx={{ color: '#B0BEC5', textAlign: 'center', mb: 5, fontSize: { xs: '1rem', sm: '1.25rem' } }}>
                    Here's some of my favourites from my wildlife photos.
                </Typography>

                {wildlifeData.length === 0 ? (
                    <Typography variant="body1" sx={{ color: '#B0BEC5', textAlign: 'center' }}>
                        Photos coming soon.
                    </Typography>
                ) : (
                    <Stack spacing={{ xs: 5, sm: 8 }} sx={{ width: '100%', minWidth: 0 }}>
                        {wildlifeData.map((photo, index) => (
                            <WildlifePhotoCard
                                key={index}
                                image={photo.image}
                                caption={photo.caption}
                                slideDirection={index % 2 === 0 ? 'left' : 'right'}
                            />
                        ))}
                    </Stack>
                )}
            </Box>
        </Box>
    );
};

export default WildSidePage;
